module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, positioning;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      positioning = this.top != null ? "top: " + this.top + "px;" : "";
      $o.push("<div class='comment-list-container maskable' style='" + ($e($c(positioning))) + "'>\n  <div class='" + (['comment-box-wrapper', "new-comment " + ($e($c(!this.targeted ? 'comment-tab-form' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n    <div class='comment-form-container js-inline-comment-form'>\n      <form class='new-comment' action='/stories/" + ($e($c(this.storyId))) + "/comments' data-validation='structured' method='post'>\n        <input type='hidden' name='comment[highlighted_text]' value='" + ($e($c(this.highlightedText))) + "'>\n        <input type='hidden' name='comment[parent_id]' value=''>\n        <input type='hidden' name='comment[mark_id]' value='" + ($e($c(this.markId))) + "'>\n        <div class='row'>\n          <label class='required' for='comment_body'>Leave a comment</label>\n          <textarea id='comment_body' name='comment[body]' rows='2'></textarea>\n        </div>\n        <div class='actions row row-half'>\n          <a class='button js-cancel small transparent' href='javascript:;'>Cancel</a>\n          <button class='button secondary small'>Comment</button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/comments/comment_form.js.hamlc
// module id = 1771
// module chunks = 19